import { graphql } from "@opensea/graphql"

export const TreasureChestWaveFragment = graphql(`
  fragment TreasureChestWave on TreasureChest {
    id
    name
  }
`)
